// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1bcc5225","453":"842c90a1","455":"350c0257","977":"9d35a6f7"}[chunkId] + ".chunk.js";
};